import React, { useState, useEffect } from 'react';
import axios from 'utils/axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Pagination from 'components/Pagination';
import { MdAddCircle } from 'react-icons/md';
import { Button } from 'react-bootstrap';




const CodebookList = () => {

  const { t } = useTranslation();

  const navigate = useNavigate();

  const { codebookType } = useParams();


  const [codebooks, setCodebooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');


  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const itemsPerPage = 10;

  const fetchCodebooks = async (codebookType, currentPage) => {
    try {

      const response = await axios.get(`codebook?codebook=${codebookType}`, {
        params: {
          page: currentPage,
          count: itemsPerPage,
          //search: query, 
        },
      });

      setCodebooks(response.data);
      setTotalPages(Math.ceil(response.data.total / itemsPerPage));

      setLoading(false);
    } catch (err) {
      toast.error(t('error_fetching_items'));
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchCodebooks(codebookType, currentPage);
  }, [codebookType, currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }


  return (
    <div className="container mt-5">
      {/* <h1>{t('codebooksList')}</h1> */}

      <div className="d-flex justify-content-between align-items-center mb-3" onClick={() => navigate(`/codebook/${codebookType}/adding`)}>
        <h2>                        {t(`${codebookType}`)}      </h2>
        <Button variant="primary" onClick={() => navigate('/addrole')}>
          <MdAddCircle className="me-2" size={20} />
          {t('add')}
        </Button>
      </div>
      <br />




      <table className="table w-full text-sm text-left border-collapse">
        <thead className="border-b">
          <tr>
            <th>{t('title')}</th>
            <th>{t('code')}</th>
            <th>{t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {codebooks.map((codebook) => (
            <tr key={codebook.id} className="border-b hover:bg-gray-50">
              <td>{codebook.name}</td>
              <td>{codebook.code}</td>
              <td>
                <Link
                  to={`/codebook/${codebookType}/edit/${codebook.id}`}
                  className="text-blue-600 hover:underline"
                >
                  {t('edit')}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
        loading={loading}
      />
    </div>
  );
};

export default CodebookList;